import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { HistoryTrigger } from 'api/InteractiveMap/types';

interface Props {
  title: string;
  trapType: 'smst' | 'srst';
  isOpen: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  historyTriggers?: HistoryTrigger[];
}

const CustomTooltip: React.FC<Props> = ({ title, trapType, isOpen, onMouseEnter, onMouseLeave, historyTriggers }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;
  return (
    <div
      className="popover"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        width: '100%',
        position: 'absolute',
        top: '75%',
        right: 0,
        left: 0,
        zIndex: 9999,
        maxHeight: '500px',
      }}
    >
      <div className="popover-header m-0 py-1 bg-light">
        <div className="d-flex align-items-center mx-2 justify-content-between gap-2">
          <div className="d-flex">{title}</div>
          <div className="d-flex align-items-center" />
        </div>
      </div>
      <div className="popover-body text-center">
        {!historyTriggers?.length ? (
          <h6>{t('MCTDetail.heatmap.no_activity')}</h6>
        ) : (
          <div
            className="d-flex flex-column gap-1 px-3"
            style={{
              alignItems: 'flex-start',
              textAlign: 'left',
              width: '100%',
              overflowY: 'scroll',
              maxHeight: '450px',
            }}
          >
            {historyTriggers!.map((activity: HistoryTrigger, index: number) => {
              const dateTime = dayjs(activity.date_time).isValid()
                ? dayjs(activity.date_time).format('DD-MM-YYYY\xa0\xa0\xa0HH:mm:ss')
                : activity.date_time;
              // const dateTime = dayjs(trimmedSignal.slice(0, -1).trim()).format('DD-MM-YYYY\xa0\xa0\xa0HH:mm:ss');
              return (
                <div className="d-flex" style={{ justifyContent: 'flex-center', width: '100%' }} key={index}>
                  {trapType !== 'srst' ? (
                    activity.enter === 'R' ? (
                      <div className="d-flex" style={{ gap: '6px' }}>
                        <div>{dateTime}</div>
                        <div className="d-flex" style={{ alignItems: 'center' }}>
                          <div>R</div>
                          <i className="ri-arrow-left-line" />
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex" style={{ gap: '6px' }}>
                        <div>{dateTime}</div>
                        <div className="d-flex" style={{ alignItems: 'center' }}>
                          <i className="ri-arrow-right-line" />
                          <div>L</div>
                        </div>
                      </div>
                    )
                  ) : (
                    <div>{dateTime}</div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomTooltip;
